<template>
  <b-card title="ผลการค้นหา">
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <!-- <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group> -->
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      @on-row-click="onRowClick"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      @on-page-change="onPageChange"
      @on-per-page-change="onPageLengthChange"
      :totalRows="totalRecords"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'caseCode'" class="text-nowrap">
          {{ props.row.objectiveText }}
          <br />
          {{ props.row.caseCode }}
        </span>

        <span
          v-if="props.column.field === 'complaintSubject'"
          class="text-nowrap"
        >
          {{ props.row.secretText }} - {{ props.row.typeText }}
          <br />
          <span
            v-if="props.row.summary !== null && props.row.summary !== undefined"
          >
            {{ props.row.summary.substring(0, 50)
            }}{{ props.row.summary.length >= 50 ? "..." : "" }}
          </span>
        </span>

        <span v-if="props.column.field === 'action'" class="text-nowrap">
          <feather-icon icon="FileTextIcon" class="mr-50" />
          {{ props.row.operatingDateStr }}
          <br />
          {{ props.row.statusText }}
          <br />
          {{ getStatusDescription(props.row.processlevel) }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  VBTooltip,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import { codeBasic } from "@/views/table/vue-good-table/code";
import appsettings from "@/store/app-settings";

import TableHeaders from "./commonTableHeader.js";
import * as gccStore from "@/store/api/gcc/index.js";
import * as userData from "@/auth/localStorageUtils.js";

export default {
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    TableHeaders,
  },
  props: {
    searchMode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    return {
      tabMode: props.mode,
    };
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      codeBasic,
      columns: TableHeaders,
      rows: [],
      searchTerm: "",
      params: {},
      totalRecords: 0,
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  methods: {
    getStatusDescription(status) {
      if (status === 1) {
        return "รอรับเรื่อง";
      } else if (status === 2) {
        return "รับเรื่องเข้าร้องทุกข์";
      } else if (status === 3) {
        return "รับเรื่องเข้าแจ้งเบาะแส";
      } else if (status === 4) {
        return "ขอเอกสารเพิ่มเติม";
      } else if (status === 5) {
        return "ไม่ได้อยู่ในอำนาจหน้าที่";
      } else if (status === 6) {
        return "รับทราบเรื่อง";
      } else {
        return "มีการอัพเดทข้อมูล";
      }
    },
    onRowClick(params) {
      if (this.tabMode !== "History" && this.tabMode !== "Update") {
        const routeData = this.$router.resolve({
          name: "GCCManage",
          query: { id: params.row.caseId },
        });
        window.open(routeData.href, "_blank");
      }
    },
    onSearchSubmit(params, page = { currentPage: 1 }) {
      var _this = this;

      this.params = params;

      params.page = page.currentPage;
      params.perPage = this.pageLength;

      _this.$emit("handleOverlay", true);

      if (this.searchMode == "Waiting") {
        params.statusId = 1;
        gccStore
          .getForSearch(params)
          .then(function(response) {
            _this.rows = response.data.data;
            try {
              _this.totalRecords = response.data.data[0].totalCount;
            } catch (ex) {
              console.log("get total records error", ex);
              _this.totalRecords = 0;
            }
          })
          .catch(function(error) {
            console.log("error", error);
            _this.rows = [];
            _this.totalRecords = 0;
          })
          .then(function() {
            _this.$emit("handleOverlay", false);
          });
      } else if (this.searchMode == "History") {
        params.statusId = 234;
        gccStore
          .getForSearch(params)
          .then(function(response) {
            _this.rows = response.data.data;
            try {
              _this.totalRecords = response.data.data[0].totalCount;
            } catch (ex) {
              console.log("get total records error", ex);
              _this.totalRecords = 0;
            }
          })
          .catch(function(error) {
            console.log("error", error);
            _this.rows = [];
            _this.totalRecords = 0;
          })
          .then(function() {
            _this.$emit("handleOverlay", false);
          });
      } else {
        params.statusId = 10;
        gccStore
          .getForSearch(params)
          .then(function(response) {
            _this.rows = response.data.data;
            try {
              _this.totalRecords = response.data.data[0].totalCount;
            } catch (ex) {
              console.log("get total records error", ex);
              _this.totalRecords = 0;
            }
          })
          .catch(function(error) {
            console.log("error", error);
            _this.rows = [];
            _this.totalRecords = 0;
          })
          .then(function() {
            _this.$emit("handleOverlay", false);
          });
      }
    },
    onPageChange(page) {
      console.log("onPageChanged", page);
      this.onSearchSubmit(this.params, page);
    },
    onPageLengthChange(pageLength) {
      console.log("onPageLengthChanged", pageLength);
      this.onSearchSubmit(this.params, 1);
    },
    onComplainSend(id) {
      this.$emit("handleSend", id);
    },
    onComplainGroupManage(id) {
      this.$emit("handleGroup", id);
    },
    onComplaintFormClicked(id) {
      const url = appsettings.complaintFormUrl.replace("{0}", id);
      window.open(url, "_blank");
    },
    confirmText() {
      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$swal({
            icon: "success",
            title: "ลบข้อมูล สำเร็จ",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
  },
};
</script>
